import React, { ReactElement } from 'react';

import {
  CardContainer,
  StyledAvatar,
  TitleContainer,
} from './style';

interface AccessCardProps {
  title: string
  icon: ReactElement | string
  action(): void
}

const AccessCard = ({
  title,
  icon,
  action,
}: AccessCardProps): JSX.Element => (
  <CardContainer type="ghost" onClick={action}>
    <StyledAvatar size={60}>
      {icon}
    </StyledAvatar>
    <TitleContainer>
      {title}
    </TitleContainer>
  </CardContainer>
);

export default AccessCard;
